import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';
declare let $: any;

@Component({

  selector: 'app-taxi-calendar',

  templateUrl: './taxi-calendar.component.html',

  styleUrls: ['./taxi-calendar.component.css']

})

export class TaxiCalendarComponent implements OnInit {

  lst_Drivers = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(''),

    strEDate: new FormControl(momentJalaali().add(1, 'days'))

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

  }

  search_Drivers = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_Ready4Trip_ORG_Search`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Drivers = res;


  }

}
